import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c07ee4ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "SwiperOne-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangyige"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangyige-copy"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_swiper, {
    class: "SwiperOne-swiper",
    modules: $setup.modules,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    speed: 500,
    loop: true,
    navigation: $setup.navigation,
    onSwiper: $setup.onSwiper,
    onSlideChange: $setup.onSlideChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dataArr, (item, index) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: index
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
          item: item,
          index: index
        }, undefined, true)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 3
  }, 8, ["modules", "navigation", "onSwiper", "onSlideChange"]), _createElementVNode("div", {
    class: "SwiperOne-button SwiperOne-button-prev swiper-button-prev",
    onClick: _cache[0] || (_cache[0] = $event => $options.toPre(_ctx.item, _ctx.index))
  }, _hoisted_3), _createElementVNode("div", {
    class: "SwiperOne-button SwiperOne-button-next swiper-button-next",
    onClick: _cache[1] || (_cache[1] = $event => $options.toNext(_ctx.item, _ctx.index))
  }, _hoisted_5)]);
}